export default __webpack_public_path__ + "static/media/delete-entity.fcfd1522.svg";